import React from "react"
import classNames from "classnames"
import {ClientOrgBankAgreement} from "../../../resources/clientOrgBankAgreement"

interface BankNavigationsTabsProps {
	clientOrgBankAgreements: ClientOrgBankAgreement[]
	currentTab: string
	setCurrentTab: (tab: string) => void
}

export function BankNavigationsTabs({
	clientOrgBankAgreements,
	currentTab,
	setCurrentTab,
}: BankNavigationsTabsProps): JSX.Element {
	return (
		<>
			{clientOrgBankAgreements.map((clientOrgBankAgreement) => {
				const bankName = clientOrgBankAgreement.attributes.bankName
				if (!bankName) return null
				return (
					<li
						key={clientOrgBankAgreement.id}
						className={classNames(currentTab === bankName && "is-active")}
						onClick={() => setCurrentTab(bankName)}
					>
						<a>{bankName}</a>
					</li>
				)
			})}
		</>
	)
}
